import React from "react";
import { Check } from "lucide-react";

const BENEFITS = [
  "Discuss your yoga goals",
  "Understand the class format",
  "Meet or speak with a teacher",
  "Ask questions before booking",
];

export default function ConsultationCtaSection({ onBookConsultation }) {
  return (
    <section
      id="free-consultation"
      className="scroll-mt-28 bg-gray-50/80"
      aria-labelledby="consultation-heading"
    >
      <div className="container mx-auto px-4 py-16 md:py-20">
        <div className="mx-auto max-w-3xl overflow-hidden rounded-3xl border border-gray-100 bg-white shadow-sm">
          <div className="bg-gradient-to-r from-emerald-600 to-teal-700 px-6 py-8 text-white sm:px-10 sm:py-10">
            <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-emerald-100">
              Free 15-minute consultation
            </p>
            <h2
              id="consultation-heading"
              className="mt-2 text-2xl font-bold tracking-tight sm:text-3xl"
            >
              Not Sure Which Yoga Teacher Is Right for You?
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-emerald-50/95 sm:text-[15px]">
              Tell us about your goals, experience and preferred schedule. We&apos;ll help you find a
              yoga teacher who is a good match for your needs.
            </p>
          </div>

          <div className="px-6 py-8 sm:px-10 sm:py-9">
            <ul className="grid gap-3 sm:grid-cols-2">
              {BENEFITS.map((label) => (
                <li key={label} className="flex items-start gap-2.5 text-sm text-gray-700">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-700">
                    <Check size={14} strokeWidth={2.5} />
                  </span>
                  <span className="leading-snug pt-0.5">{label}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <button
                type="button"
                onClick={onBookConsultation}
                className="inline-flex items-center justify-center rounded-lg bg-emerald-600 px-6 py-3.5 text-sm font-semibold text-white shadow-sm shadow-emerald-200 transition-colors hover:bg-emerald-700"
              >
                Book My Free Consultation
              </button>
              <p className="text-sm text-gray-500">No obligation to book</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
